import { useApolloClient, useMutation } from '@apollo/react-hooks';
import { CREATE_BUSINESS } from '../../graphql/business/mutation';
import {
  CreateBusiness,
  CreateBusinessVariables,
} from '../../graphql/business/types/CreateBusiness';
import { displaySnackBar } from '../../common/displaySnackbar';
import { formatName } from '../../utils/common';
import { ApiErrorCode } from '../../common/constants';

export const useCreateBusiness = () => {
  const client = useApolloClient();

  return useMutation<CreateBusiness, CreateBusinessVariables>(CREATE_BUSINESS, {
    update: (client, { data }) => {
      if (!data?.createBusiness) return;

      const { firstName, lastName } = data?.createBusiness;

      displaySnackBar(client, {
        type: 'SUCCESS',
        isOpen: true,
        message: `Affaire ${formatName({ firstName, lastName })}`,
      });
    },

    onError: ({ graphQLErrors }) => {
      if (graphQLErrors?.length) {
        if (graphQLErrors[0]?.extensions?.code === ApiErrorCode.ALREADY_EXIST)
          displaySnackBar(client, {
            type: 'ERROR',
            isOpen: true,
            message: `L'adresse électronique ou le numéro de téléphone spécifié est déjà utilisé.`,
          });
      }
    },
  });
};
